import { render, staticRenderFns } from "./EditUserCard.vue?vue&type=template&id=205380fc&scoped=true&"
import script from "./EditUserCard.vue?vue&type=script&lang=js&"
export * from "./EditUserCard.vue?vue&type=script&lang=js&"
import style0 from "./EditUserCard.vue?vue&type=style&index=0&id=205380fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205380fc",
  null
  
)

export default component.exports